import type {FocusTrap} from "focus-trap";
import * as focusTrap from 'focus-trap';

export const createFocusTrap = (element: HTMLElement): FocusTrap => {
    return focusTrap.createFocusTrap(element)
}